import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectionCard } from 'components/SelectionCard/SelectionCard';
import styles from '../SelectCategoryStep.scss';
import { Category } from 'config/enums';
import { categoryItemProps } from 'config/maps';
import { useAppStore } from 'stores/state';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectCategoryStepOptions: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const category = useAppStore((state) => state.category);
  const setCategory = useAppStore((state) => state.setCategory);

  const handleSelectCategory = (categoryKey: Category) => {
    setCategory(categoryKey);
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SelectCategory],
      button_name: BI_BUTTON_NAME.OPTION_SELECTED,
      action: BI_ACTION_NAME.NEXT,
      value: categoryKey,
    });
    next();
  };

  return (
    <div className={styles.selectCategoryStepOptions}>
      {Object.values(Category).map((categoryKey) => {
        const Icon = categoryItemProps[categoryKey].icon;
        return (
          <SelectionCard
            title={t(`select-category-step.options.item.title.${categoryKey}`)}
            onClick={() => handleSelectCategory(categoryKey)}
            isSelected={category === categoryKey}
            icon={<Icon />}
            key={categoryKey}
          />
        );
      })}
    </div>
  );
};
